<template>
  <AppView title="會員註冊" :footerShow="true">
    <main class="min-h-app bg-gray-50 pb-24 desk:flex desk:min-h-0 desk:flex-1 desk:flex-col desk:bg-white desk:pb-0">
      <div class="desk:grid desk:min-h-0 desk:flex-1 desk:grid-cols-2 desk:items-stretch">
        <section
          class="border-b border-gray-100 bg-white px-5 py-6 desk:flex desk:flex-col desk:justify-start desk:border-b-0 desk:border-r desk:px-8 desk:py-8"
        >
          <p class="text-xs font-medium text-gray-400 desk:text-dove-gray">新會員</p>
          <h1 class="mt-2 text-xl font-bold text-gray-900 desk:text-2xl">建立會員帳號</h1>
          <p class="mt-2 text-sm leading-6 text-gray-500 desk:mt-3">
            完成電話認證後即可購買商品，訂單紀錄會保存到會員帳號。
          </p>
          <ul class="mt-8 hidden space-y-7 desk:block">
            <li class="flex items-start gap-3">
              <DeviceMobileIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">電話認證</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">用短訊完成會員驗證</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <ShoppingBagIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">購買商品</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">認證後即可落單付款</p>
              </div>
            </li>
            <li class="flex items-start gap-3">
              <ClipboardListIcon class="mt-0.5 h-6 w-6 flex-none text-primary" />
              <div>
                <p class="text-sm font-semibold text-gray-900">訂單紀錄</p>
                <p class="mt-0.5 text-xs leading-5 text-gray-400">保存到會員帳號</p>
              </div>
            </li>
          </ul>
        </section>

        <section
          data-desktop-auth-column
          class="mt-2 border-y border-gray-100 bg-white px-5 py-5 desk:mt-0 desk:flex desk:flex-col desk:justify-start desk:border-0 desk:px-8 desk:py-8"
        >
          <div class="desk:mx-auto desk:w-full desk:max-w-[400px]">
            <h2 class="mb-5 text-sm font-bold text-gray-900">會員資料</h2>
            <RegisterForm @login="submit" :disabled="posting" />
          </div>
        </section>
      </div>
    </main>
  </AppView>
</template>

<script>
import RegisterForm from "@/components/forms/RegisterForm.vue";
import {
  ClipboardListIcon,
  DeviceMobileIcon,
  ShoppingBagIcon,
} from "@vue-hero-icons/outline";
export default {
  components: {
    RegisterForm,
    ClipboardListIcon,
    DeviceMobileIcon,
    ShoppingBagIcon,
  },
  auth: "guest",
  head() {
    return {
      title: `${this.$store.getters['app/info']?.name || process.env.APP_NAME}-會員註冊`,
    };
  },
  data() {
    const user = this.$auth.user?.data;
    return {
      posting: false, // 提交中
    };
  },

  methods: {
    submit(data) {
      // 當在提交中，不再提交
      if (this.posting) return;
      this.posting = true;
      this.$auth
        .loginWith("local", { data: data })
        .then(() => {
          if (this.$track) {
            this.$track.event("login", {
              method: "local",
              source: "sign_up",
              country_code: data?.country_code,
            });
          }
        })
        .catch((err) => {
          if (err && err.response) {
            this.handleErrorsMessage(err);
          } else {
            this.$loader.error("註冊成功，但自動登入失敗，請手動登入");
          }
        })
        .finally(() => {
          this.posting = false;
        });
    },
  },
};
</script>

<style lang="css" scoped></style>
